import { integerValue, isMaximum } from '~/utils';

const onlyPhone = value => !isMaximum(integerValue(value), 11) && /^[\d ()-]{0,}$/g.test(value);

export default onlyPhone;
